import { useParams } from "react-router-dom";
import { usePortalFlows } from "hooks/usePortalFlows";

export const useSlugFlow = () => {
  const { flows, handleFetchFlows } = usePortalFlows();
  const params = useParams();

  return {
    flow: flows?.find((flow) => flow.id === params.slug),
    handleFetchFlows,
  };
};
